/**
 * @author Ivan Toth.
 *  Stores data about app settins, like country, user profile
 */
var SearchSubmitService = (function () {
    function SearchSubmitService() {
        this.laterProcess = false;
    }
    SearchSubmitService.prototype.updateLaterProcess = function (processLater) {
        this.laterProcess = processLater;
    };
    SearchSubmitService.prototype.checkIfReportLoaded = function () {
        if (angular.isUndefined(this.original) || angular.isUndefined(this.original.table)) {
            return false;
        }
        else {
            return true;
        }
        ;
    };
    SearchSubmitService.prototype.updateSearchResults = function (data) {
        var _this = this;
        this.laterProcess = false;
        angular.forEach(data.type, function (tempType) {
            _this.type = tempType;
        });
        this.original = { table: [] };
        if (angular.isDefined(data.response)) {
            this.original = data.response;
        }
        this.results = angular.copy(this.original);
        this.results.table = [];
    };
    SearchSubmitService.prototype.updateOriginal = function (data) {
        this.original = data;
    };
    SearchSubmitService.prototype.updateResults = function (data) {
        this.results = data;
    };
    SearchSubmitService.prototype.removeItem = function (item) {
        var position = -1;
        for (var i = 0; i < this.results.table.length; i++) {
            var tableItem = this.results.table[i];
            var found = true;
            for (var prop in tableItem) {
                if (prop != '$$hashKey' && tableItem[prop] != item[prop]) {
                    found = false;
                }
            }
            if (found) {
                position = i;
                break;
            }
        }
        if (position > -1) {
            this.results.table.splice(position, 1);
            return true;
        }
        else {
            return false;
        }
    };
    SearchSubmitService.prototype.addItem = function (item) {
        if (this.results.table.indexOf(item) < 0) {
            this.results.table.push(item);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Function to return a human readable name for the various search result items
     * @param keyword
     */
    SearchSubmitService.prototype.getItemName = function (keyword) {
        console.info(keyword);
        switch (keyword) {
            case 'dc':
                return 'Duplicate Check';
            case 'cmr':
            case 'cmr_valid':
                return 'Find CMR';
            case 'nc':
                return 'New Client';
            case 'fastpass':
                return 'Fastpass';
            default:
                if (angular.isDefined(keyword)) {
                    return keyword.toUpperCase();
                }
                return 'Unknown Search Results';
        }
    };
    return SearchSubmitService;
}());
angular
    .module('application')
    .service('searchSubmit', SearchSubmitService);

//# sourceMappingURL=searchSubmit.js.map
